import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bcf19d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block-wrap" }

import { computed, ref, CSSProperties, withDefaults } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'shrink-wrap',
  props: {
    title: { default: '' },
    titleStyle: { default: () => null },
    titleWrapStyle: null
  },
  emits: ['update:isShrink'],
  setup(__props: any, { expose, emit }) {

const props = __props as { title: string, titleStyle: CSSProperties, titleWrapStyle?: CSSProperties };



let isShrink = ref(false)

expose({
  setShrink(value: boolean) {
    isShrink.value = value
  },
})


const tipText = computed(() => {
  return isShrink.value ? '展开' : '收起'
})
function shrinkClickHandle() {
  console.log('shrinkClickHandle', isShrink.value)
  isShrink.value = !isShrink.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "block-title-wrap",
      style: _normalizeStyle(props.titleWrapStyle)
    }, [
      _createElementVNode("span", {
        class: "block-title",
        style: _normalizeStyle(props.titleStyle)
      }, _toDisplayString(props.title), 5),
      _createElementVNode("div", {
        class: "block-flag-wrap",
        onClick: shrinkClickHandle
      }, [
        _createElementVNode("span", null, _toDisplayString(_unref(tipText)), 1),
        _createElementVNode("div", {
          class: _normalizeClass(["icon-down-svg arrow", { down: !_unref(isShrink) }])
        }, null, 2)
      ])
    ], 4),
    _createElementVNode("div", {
      class: _normalizeClass({ 'is-hide': _unref(isShrink) })
    }, [
      _renderSlot(_ctx.$slots, "content")
    ], 2)
  ]))
}
}

})